<template lang="html">
  <div class="container-fluid p-5">
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            Member List
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="row search-form">
                  <div class="col-md-3 mt-1">
                    <input
                      type="text"
                      v-model="filter.name"
                      class="form-control"
                      placeholder="Name"
                    />
                  </div>
                  <div class="col-md-3 mt-1">
                    <input
                      type="text"
                      v-model="filter.phone"
                      class="form-control"
                      placeholder="Phone"
                    />
                  </div>
                  <div class="col-md-3 mt-1">
                    <input
                      type="text"
                      v-model="filter.email"
                      class="form-control"
                      placeholder="Email"
                    />
                  </div>
                  <div class="col-md-3 mt-1">
                    <input
                      type="text"
                      v-model="filter.agent_name"
                      class="form-control"
                      placeholder="Agent Name"
                    />
                  </div>
                  <div class="col-md-3 mt-1">
                    <select v-model="filter.has_agent" class="form-control">
                      <option value="">Seclect Connect Agent</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                  </div>
                  <div class="col-md-3 mt-1">
                    <select v-model="filter.deposit_apply" class="form-control">
                      <option value="">Seclect Deposit Apply</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                  </div>
                  <div class="col-md-4 mt-1">
                    <button
                      class="btn btn-primary mr-1 fbutton"
                      @click="search()"
                    >
                      <i class="fas fa-search"></i> Search
                    </button>
                    <button class="btn btn-info fbutton" @click="reset()">
                      <i class="fas fa-sync"></i> Refresh
                    </button>
                  </div>
                </div>
                <button
                  class="btn btn-info fbutton d-flex flex-row justify-content-center gap-2 align-items-center"
                  style="width: 100px; margin-top: 20px;"
                  @click="send()"
                >
                  <i class="fas fa-bell"></i> Send
                  <span v-if="selectedUserIds.length">{{
                    this.selectedUserIds.length
                  }}</span>
                </button>
              </div>
            </div>
            <div class="table-responsive mt-4">
              <table class="common-table">
                <thead>
                  <tr>
                    <th>Action</th>
                    <th
                      v-for="(value, key) in columns"
                      :key="key"
                      @click="sortBy(key)"
                      style="cursor:pointer;text-align: left;"
                    >
                      {{ value }}
                      <span v-if="filter.sortKey === key">
                        <i
                          v-if="filter.orderBy === 'asc'"
                          class="fas fa-sort-up"
                        ></i>
                        <i v-else class="fas fa-sort-down"></i>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in dataList"
                    :key="data.id"
                    :class="{ 'inactive-row': data.is_active == 0 }"
                  >
                    <td>
                      <button
                        v-b-modal.bv-modal-password
                        class="btn btn-sm btn-info mr-1"
                        @click="editData(data)"
                      >
                        <i class="fas fa-lock"></i> Reset Password
                      </button>
                      <button
                        v-b-modal.bv-modal-pin
                        class="btn btn-sm btn-info mr-1"
                        @click="editData(data)"
                      >
                        <i class="fas fa-lock"></i> Reset PIN
                      </button>
                    </td>
                    <td
                      class="d-flex justify-content-between align-items-center"
                    >
                      <span>{{ data.user_name }}</span>
                      <input
                        type="checkbox"
                        class="ml-2"
                        :value="data.user_id"
                        v-model="selectedUserIds"
                      />
                    </td>
                    <td>{{ data.phone_or_email }}</td>
                    <td>{{ data.user_amount }}</td>
                    <td>{{ data.agent_name }}</td>
                    <td>{{ data.user_total_bet_amount }}</td>
                    <td>{{ data.user_total_win_amount }}</td>
                    <td>{{ data.user_total_lost_amount }}</td>
                    <td>{{ data.user_total_deposit_amount }}</td>
                    <td>{{ data.user_total_withdraw_amount }}</td>
                    <td>{{ data.created_at }}</td>
                  </tr>
                  <tr v-if="dataList.length === 0">
                    <td
                      :colspan="Object.keys(columns).length + 1"
                      class="text-center"
                    >
                      Empty List
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="table-pagination-minimal">
              <div class="table-pagination-row">
                <div
                  v-if="dataList.length > 0"
                  class="table-info-minimal left-align"
                >
                  Showing <span>{{ metaData.from }}</span> to
                  <span>{{ metaData.to }}</span> of
                  <span>{{ metaData.total }}</span> entries
                </div>
                <nav class="pagination-minimal">
                  <ul>
                    <li :class="{ disabled: metaData.prev_page_url === null }">
                      <button
                        @click.prevent="next(metaData.current_page - 1)"
                        :disabled="metaData.prev_page_url === null"
                      >
                        <i class="fas fa-angle-left"></i>
                      </button>
                    </li>
                    <li
                      v-for="page in metaData.last_page"
                      :key="page"
                      :class="{ active: metaData.current_page === page }"
                      v-if="
                        Math.abs(page - metaData.current_page) < 3 ||
                          page == metaData.last_page ||
                          page == 1
                      "
                    >
                      <button @click.prevent="next(page)">{{ page }}</button>
                    </li>
                    <li
                      :class="{
                        disabled: metaData.current_page === metaData.last_page,
                      }"
                    >
                      <button
                        @click.prevent="next(metaData.current_page + 1)"
                        :disabled="metaData.current_page === metaData.last_page"
                      >
                        <i class="fas fa-angle-right"></i>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <b-modal
              id="bv-modal-status"
              ref="my-modal"
              title="Change Status"
              hide-footer
            >
              <div class="form-group">
                <label for="inputUserName">User Name</label>
                <input
                  type="text"
                  v-model="userName"
                  id="inputUserName"
                  class="form-control"
                  disabled
                />
              </div>
              <div class="form-group">
                <label for="status">Select Status</label>
                <select v-model="status" id="status" class="form-control">
                  <option value="pending">Pending</option>
                  <option value="completed">Completed</option>
                  <option value="failed">Failed</option>
                </select>
              </div>
              <b-button class="mt-3 btn-success" block @click="editStatus()"
                >Submit</b-button
              >
            </b-modal>
            <b-modal
              id="bv-modal-delete"
              ref="my-modal"
              title="Delete"
              hide-footer
            >
              <p class="my-4">Are you sure to delete ?</p>
              <p class="my-4 text-danger">{{ alert }}</p>
              <b-button class="mt-3 btn-danger" block @click="deleteItem()"
                >Delete</b-button
              >
            </b-modal>
            <b-modal
              id="bv-modal-password"
              ref="my-modal"
              title="Reset Password"
              hide-footer
            >
              <p class="my-4">Are you sure to reset password ?</p>
              <p class="my-4 text-danger">{{ alert }}</p>
              <b-button class="mt-3 btn-danger" block @click="updatePassword()"
                >Reset & Copy</b-button
              >
            </b-modal>
            <b-modal
              id="bv-modal-pin"
              ref="my-modal"
              title="Reset Pin"
              hide-footer
            >
              <p class="my-4">Are you sure to reset pin ?</p>
              <p class="my-4 text-danger">{{ alert }}</p>
              <b-button class="mt-3 btn-danger" block @click="updatePin()"
                >Reset & Copy</b-button
              >
            </b-modal>
          </div>
          <!-- close card-body -->
        </div>
        <!-- close card -->
      </div>
      <!-- close col-md-12 -->
    </div>
    <!-- close row -->
    <b-modal
      id="bv-modal-send"
      ref="sendModal"
      title="Send Notification"
      hide-footer
    >
      <div class="form-group">
        <label>Title <span class="text-danger">*</span></label>
        <input
          type="text"
          class="form-control"
          v-model="notificationRequest.title"
        />
        <small class="text-danger">{{ validationData.title }}</small>
      </div>

      <div class="form-group">
        <label>Short Description <span class="text-danger">*</span></label>
        <input
          type="text"
          class="form-control"
          v-model="notificationRequest.short_description"
        />
        <small class="text-danger">{{
          validationData.short_description
        }}</small>
      </div>

      <div class="form-group">
        <label>Body <span class="text-danger">*</span></label>
        <vue-editor v-model="notificationRequest.body" />
        <small class="text-danger">{{ validationData.body }}</small>
      </div>

      <small class="text-danger mt-3">{{ validationData.serverError }}</small>
      <b-button class="mt-3 btn-primary" block @click="submitMessage">
        Send
      </b-button>
    </b-modal>
    <b-modal
      id="bv-modal-success"
      ref="successModal"
      title="Success"
      hide-footer
    >
      <p class="my-4 text-success">Successfully Send Notification !</p>
    </b-modal>
  </div>
  <!-- close container-fluid -->
</template>
<script lang="js">
    import {
        mapState,
        mapActions
    } from 'vuex'
import env from '../../enviorments'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css';
import {
    VueEditor
} from 'vue2-editor'
export default {
    name: 'withdrawList',
    metaInfo: {
        title: "Withdraw List",
        titleTemplate: "%s ← BXB",
    },
    components: {
        Loading,
        VueEditor
    },
    data() {
        return {
            env,
            isLoading: false,
            fullPage: true,
            alert: "",
            id: '',
            userName: '',
            status: '',
            dataList: [],
            selectedUserIds: [],
            paymentMethod: [],
            permissions: '',
            columns: {
                user_name: "Name",
                user_phone_or_email: "Contact",
                user_amount: "Balance",
                agent_id: "Agent",
                user_total_bet_amount: "Bet",
                user_total_win_amount: "Win",
                user_total_lost_amount: "Lose",
                deposit: "Deposit",
                withdraw: "Withdraw",
                created_at: "Created At"
            },
            filter: {
                page: 1,
                orderBy: "asc",
                sortKey: "created_at",
                limit: 10,
                name: '',
                phone: '',
                email: '',
                has_agent: '',
                deposit_apply: '',
                payment_method_id: '',
                from: '',
                to: ''
            },
            notificationRequest: {
                title: '',
                body: '',
                short_description: '',
                user_id: [],
            },
            validationData: {
                title: "",
                body: "",
                short_description: "",
                user_id: "",
                serverError: ""

            },

            fromInputType: 'text',
            toInputType: 'text',
            metaData: {
                last_page: null,
                current_page: 1,
                from: null,
                to: null,
                total: null,
                prev_page_url: null
            }
        }
    },
    watch: {
        '$route'(to, from) {
            this.fetchData()
        }
    },
    computed: {},
    methods: {
        ...mapActions({
            memberListAction: 'memberListAction',
            updatePasswordAction: 'updateUserPasswordAction',
            updatePinAction: 'updateUserPinAction',
            notiStoreIndividualAction: "notiStoreIndividualAction"
        }),
        sortBy(column) {
            this.filter.sortKey = column
            if (this.filter.sortKey == column) {
                if (this.filter.orderBy == "asc") {
                    this.filter.orderBy = "desc"
                } else if (this.filter.orderBy == "desc") {
                    this.filter.orderBy = "asc"
                }
            } else {
                this.filter.orderBy = "asc"
            }
            this.fetchData()
        },
        async getPaymentMethod() {
            await this.paymentMethodAction().then(res => {
                this.paymentMethod = res.data
                this.isLoading = false
            }).catch(err => this.isLoading = true)
        },
        async search() {
            this.filter.page = 1
            this.fetchData()
            this.$refs['my-modal'].hide()
        },
        async fetchData() {
            this.isLoading = true
            let option = this.filter
            await this.memberListAction({
                ...option
            }).then(res => {
                if (res.success == true) {
                    this.dataList = res.data.data
                    this.metaData.last_page = res.data.meta.lastPage
                    this.metaData.current_page = res.data.meta.currentPage
                    this.metaData.prev_page_url = res.data.meta.prevPageUrl
                    this.metaData.from = res.data.meta.from
                    this.metaData.to = res.data.meta.to
                    this.metaData.total = res.data.meta.total
                    this.$router.replace({
                        path: 'member-list',
                        query: {
                            page: this.filter.page,
                            orderBy: this.filter.orderBy,
                            sortKey: this.filter.sortKey,
                            name: this.filter.name,
                            phone: this.filter.phone,
                            email: this.filter.email,
                            status: this.filter.status,
                            payment_method_id: this.filter.payment_method_id,
                            from: this.filter.from,
                            to: this.filter.to,
                            has_agent: this.filter.has_agent,
                            deposit_apply: this.filter.deposit_apply
                        }
                    }).catch(() => {})
                    this.isLoading = false;
                }
            }).catch(err => this.isLoading = true)
        },
        next: function(page) {
            this.filter.page = page
            this.fetchData();
        },
        reset() {
            this.$router.replace({
                path: 'member-list',
                query: {
                    page: 1,
                    orderBy: 'desc',
                    sortKey: 'created_at'
                }
            }).catch(() => {})
            this.$router.go()
        },
        send() {
            if (this.selectedUserIds.length === 0) {
                alert('Please select at least one user.');
                return;
            }
            this.validationData.serverError=""
            this.$refs.sendModal.show();
        },
        async submitMessage() {
            this.isLoading = true;
            let validation = this.validationRule();
            if (validation == true) {
                this.isLoading = false;
                return;
            }

            const formData = new FormData();
            formData.append("title", this.notificationRequest.title);
            formData.append("body", this.notificationRequest.body);
            formData.append("short_description",this.notificationRequest.short_description);
            formData.append("user_id", this.selectedUserIds)

            await this.notiStoreIndividualAction(
                formData
            ).then(res => {
                if (res.success === true) {
                    this.$refs.sendModal.hide();
                    this.selectedUserIds = [];
                    this.isLoading = false;
                    this.$refs.successModal.show();
                    setTimeout(() => {
                        this.$refs.successModal.hide();
                    }, 3000)
                } else {
                    this.isLoading = false;
                    this.validationData.serverError = res.message;
                }
            }).catch(err => {
                if (err.response.data.success === false) {
                    this.validationData.serverError = err.response.data.message
                }
                this.isLoading = false
            })
        },
        validationRule() {
            let isValidation = []
            if (this.notificationRequest.title == "") {
                this.validationData.title = "The title field is required."
                isValidation.push(true)
            } else {
                this.validationData.title = ""
                isValidation.push(false)
            }

            if (this.notificationRequest.short_description == "") {
                this.validationData.short_description = "Short Description is required."
                isValidation.push(true)
            } else {
                this.validationData.short_description = ""
                isValidation.push(false)
            }

            if (this.notificationRequest.body == "") {
                this.validationData.body = "The body field is required."
                isValidation.push(true)
            } else {
                this.validationData.body = ""
                isValidation.push(false)
            }


            if (isValidation.includes(true)) {
                return true
            } else {
                return false
            }
        },
        editData(data) {
            this.id = data.user_id
            this.userName = data.user_name
            this.status = data.status
        },
        async editStatus() {
            this.isLoading = true
            let option = {
                id: this.id,
                status: this.status
            }
            if (this.status == 'completed') {
                await this.withdrawStatusCompletedAction({
                    ...option
                }).then(res => {
                    if (res.success == false) {
                        this.alert = res.message
                    } else {
                        this.id = "",
                            this.status = "",
                            this.userName = "",
                            this.$refs['my-modal'].hide()
                    }
                    this.fetchData()
                    this.isLoading = false;
                }).catch(err => this.isLoading = true)
            }

            if (this.status == 'failed') {
                await this.withdrawStatusFailedAction({
                    ...option
                }).then(res => {
                    if (res.success == false) {
                        this.alert = res.message
                    } else {
                        this.id = "",
                            this.status = "",
                            this.userName = "",
                            this.$refs['my-modal'].hide()
                    }
                    this.fetchData()
                    this.isLoading = false;
                }).catch(err => this.isLoading = true)
            }
        },
        async updatePassword() {
            this.isLoading = true
            let option = {
                user_id: this.id,
            }
            console.log(option)
            await this.updatePasswordAction({
                ...option
            }).then(res => {
                if (res.success == false) {
                    this.alert = res.message
                } else {
                    const passData = res.data
                    const textToCopy = `Phone: ${passData.phone} | Password: ${passData.password}`;
                    navigator.clipboard.writeText(textToCopy).then(() => {
                        alert(textToCopy + '\n\nCopied to clipboard');
                    }).catch(err => {
                        // Fallback: show the credentials so user can copy manually
                        alert('Failed to copy to clipboard. Please copy manually:\n' + textToCopy + '\nError: ' + err);
                    });
                    this.id = ""
                    this.$refs['my-modal'].hide()
                }
                this.isLoading = false;
            }).catch(err => this.isLoading = true)
        },
        async updatePin() {
            this.isLoading = true
            let option = {
                user_id: this.id,
            }
            await this.updatePinAction({
                ...option
            }).then(res => {
                if (res.success == false) {
                    this.alert = res.message
                } else {
                    const pinData = res.data
                    const textToCopy = `Phone: ${pinData.phone} | Pin: ${pinData.pin}`;
                    navigator.clipboard.writeText(textToCopy).then(() => {
                        alert(textToCopy + '\n\nCopied to clipboard');
                    }).catch(err => {
                        // Fallback: show the credentials so user can copy manually
                        alert('Failed to copy to clipboard. Please copy manually:\n' + textToCopy + '\nError: ' + err);
                    });
                    this.id = ""
                    this.$refs['my-modal'].hide()
                }
                this.isLoading = false;
            }).catch(err => this.isLoading = true)
        },
        deleteData(data) {
            this.id = data.id
            this.alert = ""
        },
        async deleteItem() {
            this.isLoading = true
            let option = {
                id: this.id,
            }
            await this.withdrawDeleteAction({
                ...option
            }).then(res => {
                if (res.status == 'fail') {
                    this.alert = res.message
                } else {
                    this.$refs['my-modal'].hide()
                }
                this.fetchData()
                this.isLoading = false;
            }).catch(err => this.isLoading = true)
        },
        checkPermission: function(key) {
            if (key in this.permissions) {
                return true
            } else {
                return false
            }
        }

    },
    async mounted() {
        let user = JSON.parse(window.localStorage.getItem('user'))
        this.permissions = user.permissions
        this.filter.page = this.$route.query.page
        this.filter.orderBy = this.$route.query.orderBy
        this.filter.sortKey = this.$route.query.sortKey
        this.filter.name = this.$route.query.name || ''
        this.filter.phone = this.$route.query.phone || ''
        this.filter.email = this.$route.query.email || ''
        this.filter.status = this.$route.query.status || ''
        this.filter.payment_method_id = this.$route.query.payment_method_id || ''
        this.filter.from = this.$route.query.from || ''
        this.filter.to = this.$route.query.to || ''
        await this.fetchData()
        await this.getPaymentMethod()
    }
}
</script>
<style scoped lang="scss">
/* Large commission modal custom width */
.commission-modal-lg .modal-dialog {
  max-width: 900px;
}
.badge-16 {
  font-size: 16px;
}

/* Inactive row highlight */
.inactive-row {
  background: #f3c5c5; /* light red/pink background */
  color: #6b0019; /* darker text for contrast */
}
</style>
